import { useCallback } from 'react';
import type { HeadlineSmallOneLineCompactProps } from './types';
import { Flex } from '@banhala/ui-kit';
import { bridge, isNil, isNotNil } from '../../../../utils';
import { useOpenDeeplink } from '../../../../hooks/useOpenDeeplink';
import { HTMLText } from '../../../HTMLText';
import type { IScreensLogging } from '../../../../api/types';
import { ViewAllButton } from '../ViewAllButton';

export const HeadlineSmallOneLineCompact = ({
  header,
  screen,
}: HeadlineSmallOneLineCompactProps) => {
  const { openDeeplink } = useOpenDeeplink();
  const handleClickViewAllButton = useCallback(() => {
    if (isNil(header)) return;
    const { deeplink } = header.item;
    if (isNil(deeplink)) return;

    logClickViewAllButton({ logging: header.logging, screen });

    openDeeplink(deeplink);
  }, [header, screen, openDeeplink]);

  if (isNil(header)) {
    return null;
  }

  const hasDeeplink = isNotNil(header.item.deeplink);

  return (
    <Flex.Row
      backgroundColor="bg_always_white"
      padding={{ top: 4, bottom: 4, left: 16, right: hasDeeplink ? 0 : 16 }}
    >
      <Flex flex={1} justifyContent="center">
        <HTMLText type="h5" color="content_primary">
          {header.item.title}
        </HTMLText>
      </Flex>
      {hasDeeplink && (
        <Flex
          position="absolute"
          top={0}
          bottom={0}
          right={0}
          alignItems="center"
          justifyContent="center"
          padding={{ vertical: 8, left: 12 }}
        >
          <ViewAllButton
            onPress={handleClickViewAllButton}
            padding={{ right: 4 }}
          />
        </Flex>
      )}
    </Flex.Row>
  );
};

const logClickViewAllButton = ({ logging, screen }: { logging: IScreensLogging; screen?: string }) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_HEADLINE_SMALL_ONE_LINE_COMPACT_MORE',
    analytics: { ...logging.analytics, ...(screen != null && { SCREEN: screen }) },
    ably_only_log: logging.ably_only_log,
  });
};
